<template>
<div>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>
                   asss fund allocation  
                    frief
                </v-card-title>
            </v-card>
        </v-col>
    </v-row>
</div>
</template>
<script>
export default {
    name: 'add-fund-allocation',
    data(){
        return {
            
        }
    }
}
</script>